import "./together.scss";
import { useNavigate } from "react-router-dom";

const Together = () => {
  const navigate = useNavigate();
  const donatepage = () => {
    navigate("/donatenow");
  };
  return (
    <div>
      <div className="together-box">
        <h1>Together, We Can Make a Difference <br /> Join Pagirndhunn</h1>
        <div className="together-button-section">
          <button className="together-donate" onClick={donatepage}>Donate Now</button>
          <button className="together-becomebutton">Become A Volunteer</button>
        </div>
      </div>
    </div>
  );
};
export default Together;
